// extracted by mini-css-extract-plugin
module.exports = {"warning":"DuplicatedRequestHero_warning__o1xM7"};